import { createClient } from "@supabase/supabase-js";

// Create a single supabase client for interacting with your database
const supabase = createClient(
  "https://mjlprxfoseqzikpwbksd.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1qbHByeGZvc2VxemlrcHdia3NkIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODEyNjkyNzQsImV4cCI6MTk5Njg0NTI3NH0.RVwrXpkMi-4hN8gNo9zDff0nm4htw_IIv6cvX578HX0"
);

export default supabase;
